import { JWTAuth } from "../../../../lib/js-apiclient"
import { AdvancedApiClient } from "../../../../lib/js-apiclient/src/AdvancedApiClient";

export class FarfetchSeasonMapApiClient extends AdvancedApiClient {

    static entityType = "FarfetchSeasonMap"

    constructor(token, seasonId, id) {
        super();

        this.setEntityType(FarfetchSeasonMapApiClient.entityType)

        if(id !== undefined && id !== null) {
            this.setRoute("/api/v1/season/{sid}/farfetch-map/{id}")
                .setRouteParam("sid", seasonId)
                .setRouteParam("id", id);
        } else {
            this.setRoute("/api/v1/season/{sid}/farfetch-map")
                .setRouteParam("sid", seasonId);
        }
        
        if(token !== undefined && token !== null) {
            this.appendAuthSchema(new JWTAuth(token))
        }
    }

}